import React, {useState, useRef} from "react";
import {Link, useHistory, useParams} from "react-router-dom";
import {MUIDataTableColumnDef, MUISortOptions, SelectableRows} from "mui-datatables";
import {Bars} from "react-loader-spinner";
import moment from "moment";

import Backdrop from "@material-ui/core/Backdrop";
import Fab from "@material-ui/core/Fab";
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";

import {ApolloAxios, ApiResponse, getResultType, isSuccessApi} from "../../atom/Apollo_ApiRequest3";
import {
  APOLLO_GROUP_OPERATOR,
  APOLLO_PROFILE_SYSTEM_ADMIN,
  IsAuthorization,
} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloDataTable, DataTableOptions, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";
import {
  adclienticoneditapollo_path,
  apollo_ad_client_icons_path,
  apollo_ad_client_icon_path,
} from "../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {
  apollo_useStyles,
  options_state_edit,
  options_reviewstatus_ad_client_icon,
  options_reviewreason_ad_client_icon,
  valueToOption,
  valueToOptionNull, 
} from "../../atom/Apollo_styles";
import {ApolloTabPanel, ApolloTabs2} from "../../atom/Apollo_Tabs"

import {ApolloRightDrawerContext, RightDrawer} from "../../molecule/Apollo_RightDrawer";
import {IsAdClientIconSelectableMenu} from "../../molecule/Apollo_SelectMenu";

import GenericTemplate from "../../templates/GenericTemplate";

import {AdClientIconInfo} from "./AccountModel"
import AdClientIconFormApollo, {AdClientIconProcessType} from "./AdClientIconFormApollo";

const AdClientIconPageApollo: React.FC = () => {

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 20,
    breadId: 1,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const {accountgroupid, accountid} = useParams<{
    accountgroupid: string,
    accountid: string
  }>();

  const initAdClientIconInfo: AdClientIconInfo = {
    adClientIconId: 0,
    adClientIconName: "",
    imageUrl: "",
    status: 0,
    approval: 0,
    denialReason: 0,
    denialReasonDetail: "",
  }

  const classes = apollo_useStyles();
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {state} = React.useContext(ApolloContext);
  const [tabstate, setTabstate] = useState(0);
  const [rows, setRows] = useState<AdClientIconInfo[]>([]);
  const [selectRow, setSelectRow] = useState<AdClientIconInfo>(initAdClientIconInfo);

  const [isEditorOpen, setIsEditorOpen] = useState<boolean>(false);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const isAuthorization = IsAuthorization(APOLLO_GROUP_OPERATOR, APOLLO_PROFILE_SYSTEM_ADMIN);
  const [adClientIconFlg, setAdClientIconFlg] = React.useState(false);
  const [progress, setProgress] = useState(false);
  const adClientIconInfo = React.useRef<AdClientIconInfo>(initAdClientIconInfo);
  const resultApi = React.useRef(-1);

  const DEFAULT_ROWS_PER_PAGE = 10;

  const [numberOfRows, setNumberOfRows] = useState<number>(() => {
    const raw = localStorage.getItem(STORAGE_KEY.APOLLO_AD_CLIENT_ICON);
    return raw ? (JSON.parse(raw)?.rowsPerPage ?? DEFAULT_ROWS_PER_PAGE) : DEFAULT_ROWS_PER_PAGE;
  });

  const [columnFilterForStatus, setColumnFilterForStatus] = useState(options_state_edit.filter(elem => elem.value !== 3).map(elem => elem.label))

  React.useEffect(() => {
    const init = async() => {
      setProgress(true);
      await getAdClientIconList();
      setProgress(false);
    }
    init();
  }, []);

  /** 一覧情報取得 */
  const getAdClientIconList = async() => {
    setRows([])
    const url = `${apollo_ad_client_icons_path}/${accountid}`;
    await ApolloAxios.get(
      url
    ).then(response => {
      const res: ApiResponse = response.data;
      if (!isSuccessApi(res.resultCode)) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : "広告主アイコン情報の取得に失敗しました",
        });
      }
      setRows(res.result ?? []);
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });
  }

  const handleOpenEditor = async(adClientIconId: number) => {
    let isSuccess = false;

    const url = `${apollo_ad_client_icon_path}/${accountid}/${adClientIconId}`;
    await ApolloAxios.get(
      url
    ).then(response => {
      const res: ApiResponse = response.data;
      if (!isSuccessApi(res.resultCode)) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : "広告主アイコン情報の取得に失敗しました",
        });
      }
      setSelectRow(res.result);
      isSuccess = true;
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });

    if (!isSuccess) return;

    setIsEditorOpen(true);
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    })
  }

  const handleCloseEditor = () => {
    setSelectRow(initAdClientIconInfo);
    setIsEditorOpen(false);
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
  }

  const handleSave = async(formData: any) => {
    let isSuccess = false;

    const adClientIconId = selectRow?.adClientIconId
    if (!adClientIconId) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "広告主アカウントIDがありません",
        }
      });
    }

    // 操作ログ出力(編集)
    adClientIconInfo.current.adClientIconId = adClientIconId
    adClientIconInfo.current.status = formData.status
    resultApi.current = 0;
    writeLog();

    const url = `${apollo_ad_client_icon_path}/${accountid}/${adClientIconId}`;
    const reqBody = {
      status: formData.status,
    }
    await ApolloAxios.put(
      url,
      reqBody,
    ).then(response => {
      const res: ApiResponse = response.data;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: getResultType(res.resultCode),
          message: res.message,
        }
      });

      if (isSuccessApi(res.resultCode)) {
        // 操作ログ(成功)
        resultApi.current = 1;
        isSuccess = true;
      } else {
        // 操作ログ(失敗)
        resultApi.current = 9;
      }
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      // 操作ログ出力(結果)
      writeLog();
    });

    if (isSuccess) {
      handleCloseEditor();
      getAdClientIconList();
    }
  }

  // 操作ログ出力
  const writeLog = () => {
    if (resultApi.current < 0) return;

    const itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: selectRow.adClientIconId === 0 ? "" : valueToOption(selectRow.status, options_state_edit).label + "",
        afterValue: adClientIconInfo.current.adClientIconId === 0 ? "" : valueToOption(adClientIconInfo.current.status, options_state_edit).label + "",
      },
    ]

    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: resultApi.current === 0 ? "execute" : "result",
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "",
      campaignName: "",
      adGroupID: "",
      adGroupName: "",
      menu: "",
      displayName: "広告主アイコン編集画面",
      category: "広告主アイコン",
      actionType: "更新",
      targetID: selectRow.adClientIconId === 0 ? "" : selectRow.adClientIconId + "",
      targetName: selectRow.adClientIconId === 0 ? "" : selectRow.adClientIconName + "",
      itemList: itemList,
    }

    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (idx: number) => {
          const row: AdClientIconInfo = rows[idx];
          const adClientIconId = row.adClientIconId
          return (
            <Tooltip title="広告編集" placement="bottom">
              <IconButton
                id="edit"
                size='small'
                onClick={e => handleOpenEditor(adClientIconId)}
              >
                <EditIcon className={classes.editIcon}/>
              </IconButton>
            </Tooltip>
          );
        }
      },
    },
    {
      name: "adClientIconId",
      label: "広告主アイコンID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "adClientIconName",
      label: "画像ファイル名",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "imageUrl",
      label: "画像プレビュー",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: string) => {
          return value !== ""
            ? (<img src={value} alt="" style={{width: '120px', borderRadius: '50%'}}/>)
            : ("");
        }
      }
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        filterList: columnFilterForStatus,
        sort: true,
        customBodyRender: (value: number) => {
          return (valueToOptionNull(value, options_state_edit)?.label)
        },
      }
    },
    {
      name: "approval",
      label: "審査ステータス",
      options: {
        filter: true,
        filterOptions: {
          renderValue: (value: any) => valueToOption(value, options_reviewstatus_ad_client_icon).label
        },
        customFilterListOptions: {
          render: (value: any) => valueToOption(value, options_reviewstatus_ad_client_icon).label
        },
        sort: true,
        customBodyRenderLite: (idx: number) => {
          const row: AdClientIconInfo = rows[idx];
          const approval = row.approval
          const denialReason = row.denialReason
          return approval === 3 ? (
            <Tooltip
              title={
                <React.Fragment>
                  <span style={{fontSize:"15px"}}>否認理由</span><br/>
                  <span style={{fontSize:"15px"}}>{valueToOptionNull(denialReason, options_reviewreason_ad_client_icon)?.label}</span>
                </React.Fragment>
              }
              placement="bottom-start"
            >
              <p>{valueToOptionNull(approval, options_reviewstatus_ad_client_icon)?.label}</p>
            </Tooltip>
          ) : (valueToOptionNull(approval, options_reviewstatus_ad_client_icon)?.label);
        }
      }
    },
  ]

  const sortOrder: MUISortOptions = {
    name: "adClientIconId",
    direction: 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const options: DataTableOptions = {
    filter: true,
    filterType: "multiselect",
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.APOLLO_AD_CLIENT_ICON) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [10, 25, 50],
    onChangeRowsPerPage: (n: number) => setNumberOfRows(n),
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.APOLLO_AD_CLIENT_ICON,
    onFilterChange: (changedColumn, filterList, type, changedColumnIndex) => {
      if (changedColumn === "status") {
        setColumnFilterForStatus(filterList[changedColumnIndex]);
      }
    },
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <IsAdClientIconSelectableMenu
        adClientIconFlg={adClientIconFlg}
        setAdClientIconFlg={setAdClientIconFlg}
        isDisplayErrMsg={true}
      >
        <Backdrop className={classes.backdrop2} open={progress}>
          <Bars color="#00BFFF" height={80} width={80}/>
        </Backdrop>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        {isEditorOpen 
          ? <RightDrawer>
            <AdClientIconFormApollo
              accountId={state.current.accountId}
              accountName={state.current.accountName}
              adClientIconInfo={selectRow}
              submitAction={handleSave}
              goBackAction={handleCloseEditor}
              processType={AdClientIconProcessType.edit}
            />
          </RightDrawer>
          : undefined
        }
  
        <ApolloTabs2 value={tabstate} setValue={setTabstate} tablabel={["画像"]}/>
        <ApolloTabPanel value={tabstate} index={0}>
          <ApolloDataTable
            title={
              isAuthorization
              ? <Tooltip title="広告主アイコン新規登録" placement="bottom">
                <Link to={`${adclienticoneditapollo_path}${accountgroupid}/${accountid}`}>
                  <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
                    <AddIcon/>
                  </Fab>
                </Link>
              </Tooltip>
              : undefined
            }
            data={rows}
            columns={columns}
            options={options}
          ></ApolloDataTable>
        </ApolloTabPanel>
      </IsAdClientIconSelectableMenu>
    </GenericTemplate>
  );
}
export default AdClientIconPageApollo;
